(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('FinancesTileViewModel', financesTileViewModelFactory);

  /** @ngInject */
  function financesTileViewModelFactory(deviceActions) {
    function FinancesTileViewModel(deviceDailyFinancesJson) {
      this.status = '';
      this.lastReportTimestamp = '';

      if (typeof deviceDailyFinancesJson !== 'undefined') {
        this.refresh(deviceDailyFinancesJson);
      }
    }

    FinancesTileViewModel.prototype.destroy = function () {};

    FinancesTileViewModel.prototype.refresh = function (
      deviceDailyFinancesJson
    ) {
      this.deviceSerial = deviceDailyFinancesJson.deviceSerial;
      getDevice.call(this);
      this.refreshFinances(deviceDailyFinancesJson);
    };

    FinancesTileViewModel.prototype.refreshFinances = function (
      deviceDailyFinancesJson
    ) {
      this.chartData = {
        facilityName: deviceDailyFinancesJson.facilityName,
        totalOnlinePayments: deviceDailyFinancesJson.online,
        totalCashPayments: deviceDailyFinancesJson.cash,
        totalChangerMoney: deviceDailyFinancesJson.changer,
        totalTokenPayments: deviceDailyFinancesJson.tokens,
        totalPosMoney: deviceDailyFinancesJson.pos
      };
      this.totalPayments = deviceDailyFinancesJson.total;
      this.tokensCount = deviceDailyFinancesJson.tokensCount;
      this.localTokensCount = deviceDailyFinancesJson.lwtTokenCount;
    };

    FinancesTileViewModel.prototype.refreshDevice = function (deviceJson) {
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();
    };

    return FinancesTileViewModel;

    function getDevice() {
      var that = this;
      deviceActions.getDevice(that.deviceSerial).then(
        function (deviceJson) {
          that.refreshDevice(deviceJson);
        },
        function () {
          //todo error handling
        }
      );
    }
  }
})();
